export default (value) => {
  value = value.trim().toLowerCase();
  value = value.replace(/@/g, "at");
  value = value.replace(/&/g, "and");
  value = value.replace(/[^a-z0-9]/gi, "-");
  value = value.replace(/-+/g, "-");
  value = value.replace(/^-|-$/, "");

  return value;
};
